"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DustDevilPreTable = void 0;
const LootTable_1 = __importDefault(require("../../../../structures/LootTable"));
const SimpleMonster_1 = __importDefault(require("../../../../structures/SimpleMonster"));
const HerbDropTable_1 = __importDefault(require("../../../subtables/HerbDropTable"));
const RareDropTable_1 = require("../../../subtables/RareDropTable");
exports.DustDevilPreTable = new LootTable_1.default()
    /* Weapons and armour */
    .add('Adamant axe', 1, 3)
    .add('Rune dagger', 1, 2)
    .add("Red d'hide vambraces", 1, 2)
    .add('Air battlestaff', 1, 2)
    .add('Earth battlestaff', 1, 2)
    .add("Black d'hide vambraces", 1, 1)
    .add('Mystic air staff', 1, 1)
    .add('Mystic earth staff', 1, 1)
    .add('Dragon dagger', 1, 1)
    .oneIn(4000, 'Dust battlestaff')
    .oneIn(32768, 'Dragon chainbody')
    /* Runes and ammunition */
    .add('Dust rune', 200, 10)
    .add('Earth rune', 300, 10)
    .add('Fire rune', 300, 10)
    .add('Chaos rune', 80, 7)
    .add('Rune arrow', 12, 5)
    .add('Soul rune', 20, 4)
    .add('Fire rune', 50, 1)
    .add('Soul rune', 50, 1)
    /* Herbs */
    .add(HerbDropTable_1.default, 1, 8)
    /* Other */
    .add('Coins', [2000, 4000], 32)
    .add('Mithril bar', 10, 3)
    .add('Ugthanki kebab', 4, 2)
    .add('Adamantite bar', 4, 1)
    /* RDT */
    .add(RareDropTable_1.GemTable, 1, 8);
const DustDevilTable = new LootTable_1.default().every('Bones').every(exports.DustDevilPreTable);
exports.default = new SimpleMonster_1.default({
    id: 423,
    name: 'Dust Devil',
    table: DustDevilTable,
    aliases: ['dust devil', 'dusty', 'dusties']
});
//# sourceMappingURL=DustDevil.js.map